// Utilidades de export a CSV compartidas: las usan el TableWrapper (grillas del sistema)
// y el artifact "tabla" del asistente.

const BOM = '﻿';

// Escapa un valor para CSV (RFC 4180): entrecomilla si hay coma, comilla o salto de línea.
export function csvEscape(value) {
  const s = String(value ?? '');
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

// Arma un CSV a partir de encabezados + filas (arrays de celdas).
export function rowsToCsv(headers, rows) {
  const head = headers.map(csvEscape).join(',');
  const body = rows.map((r) => r.map(csvEscape).join(',')).join('\n');
  return body ? `${head}\n${body}` : head;
}

// Descarga un string CSV como archivo. Antepone BOM UTF-8 para que Excel (Windows)
// muestre bien tildes y ñ.
export function downloadCsv(csv, fileName) {
  const blob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
}
